<template>
  <div>
    <div class="col-12 media-item border py-1 d-flex justify-content-between" v-for="item in items" :key="item.id" @dblclick="returnMedia( item )">
      <div><i :class="`fas ${ setIcon(item.type) }`"></i> {{ item.name }}</div>
      <button class="btn btn-sm btn-danger" @click="deleteMedia(item)"><i class="fa fa-trash"></i></button>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'

export default {
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  methods: {
    setIcon: function (completeType) {
      let type = completeType.split('/')[0]
      if ( type === "video" ) {
        return "fa-video"
      } else if ( type == "image") {
        return "fa-image"
      } else if ( type == "application") {
        return "fa-file"
      }
    },

    deleteMedia: function (item) {
      Axios.delete(`/teacher/course/media/${ item.id }`)
        .then( res => {
          this.$emit('reload')
        })
    },

    returnMedia: function ( item ) {
      this.$emit('selectMedia', item)
    }
  },
}
</script>
